<script lang="ts">
    import 'bulma/css/bulma.css';
    import '@creativebulma/bulma-divider/src/docs/static/css/bulma-divider.css';
    import Timetable from "./containers/Timetable.svelte";
    import DataService from "./application/services/DataService.ts";
    import BackgroundElement from "./presentationals/BackgroundElement.svelte";
    import {Stretch} from "svelte-loading-spinners";
    import {_, addMessages, init} from "svelte-i18n";
    import hu from '../public/assets/hu.json';
    import en from '../public/assets/en.json';
    import {writable} from "svelte/store";

    let dataPromise = DataService.getDataPromise();
    let languages = writable(localStorage.getItem("lang")!==null ? localStorage.getItem("lang") : 'hu');

    addMessages('hu', hu);
    addMessages('en',en);

    $: {
        init({
            fallbackLocale: 'hu',
            initialLocale: $languages,
        });

        localStorage.setItem("lang", $languages);
    }
</script>

<BackgroundElement/>
{#await dataPromise}
    <div class="columns p-6 mt-6 has-text-centered title has-text-white">
        <div class="column mt-6 has-text-weight-bold">
            {$_('main.loading')}
        </div>
    </div>
    <div class="columns">
        <div class="column has-text-centered">
            <Stretch size="240" color="#FFFFFF" unit="px" duration="1s"/>
        </div>
    </div>
    <div class="columns">
        <div class="column has-text-centered has-text-white has-text-weight-bold">
            PTE MIK - 2021
        </div>
    </div>
{:then data}
    <main>
        <Timetable data={data} languages={languages}/>
    </main>
{:catch error}
    <p>{error.message}</p>
{/await}